import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { displayMinimumPriceWithoutCurrency } from '../../helpers/product-price';
import AnalyticsDataWrapper from '../analytics-data-wrapper';
import ProductCard from '../product-card';
import { discountedPriceRange, priceRange, discountPercentageRange } from '../../helpers/price-ranges';
import makeUniqueProductId from '../../helpers/make-unique-product-id';
import { useAnalyticsImpressionTracker } from '../../analytics-observer/analytics-impression-tracker-context';
import { TrackBox } from '../../analytics-observer/track-box';
import { withIsAboveFoldProvider } from '../../hub-components/is-above-fold-provider';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const ABOVE_FOLD_THRESHOLD = 8;

const ProductsList = _ref => {
  let {
    products,
    page,
    itemsPerPage,
    analytics,
    sort
  } = _ref;
  const listId = analytics.productList;
  const {
    trackProductListViewedEvent
  } = useAnalyticsImpressionTracker();
  return products.length === 0 ? null : /*#__PURE__*/_jsx("div", {
    className: style.productsListGrid,
    "data-insights-query-id": analytics === null || analytics === void 0 ? void 0 : analytics.queryID,
    "data-insights-index": analytics === null || analytics === void 0 ? void 0 : analytics.indexName,
    "data-id": "products-list_index_ProductsList_div",
    children: products.map((product, index) => {
      var _discountedPriceRange, _product$variant, _product$variant$prom, _product$brand$name, _product$brand, _product$shop$retaile, _product$shop$retaile2, _product$category, _product$category2, _product$variant2, _product$variant3;

      const price = (_discountedPriceRange = discountedPriceRange(product)) !== null && _discountedPriceRange !== void 0 ? _discountedPriceRange : priceRange(product);
      const algoliaInsightsIndex = index + 1; // this is the position in the page not the whole set across all pages

      const merchandisedPromotion = (_product$variant = product.variant) === null || _product$variant === void 0 ? void 0 : (_product$variant$prom = _product$variant.promotions) === null || _product$variant$prom === void 0 ? void 0 : _product$variant$prom[0];

      const trackable = _objectSpread({
        'data-ecomm-product': 'product',
        'data-product-brand': (_product$brand$name = (_product$brand = product.brand) === null || _product$brand === void 0 ? void 0 : _product$brand.name) !== null && _product$brand$name !== void 0 ? _product$brand$name : '',
        'data-product-retailer': product.shop.name,
        'data-product-retailer-id': (_product$shop$retaile = (_product$shop$retaile2 = product.shop.retailer) === null || _product$shop$retaile2 === void 0 ? void 0 : _product$shop$retaile2.sys.id) !== null && _product$shop$retaile !== void 0 ? _product$shop$retaile : '',
        'data-product-category': (_product$category = (_product$category2 = product.category) === null || _product$category2 === void 0 ? void 0 : _product$category2[product.category.length - 1]) !== null && _product$category !== void 0 ? _product$category : '',
        'data-product-id': product.variantGroupCode,
        'data-product-unique-id': makeUniqueProductId(product.variantGroupCode, product.shop.id, (_product$variant2 = product.variant) === null || _product$variant2 === void 0 ? void 0 : _product$variant2.sku),
        'data-product-name': product.name,
        'data-product-price': displayMinimumPriceWithoutCurrency(price),
        'data-product-list': listId,
        'data-product-variant': '',
        'data-product-variant-sku': (_product$variant3 = product.variant) === null || _product$variant3 === void 0 ? void 0 : _product$variant3.sku,
        'data-product-currency': 'AUD',
        'data-product-position': itemsPerPage * page + (index + 1),
        'data-insights-object-id': product.objectID,
        'data-insights-position': algoliaInsightsIndex
      }, merchandisedPromotion && {
        'data-product-auto-promotion-id': merchandisedPromotion.campaignId,
        'data-product-auto-promotion-name': merchandisedPromotion.title
      });

      const key = [product.variantGroupCode, product.shop.id].join('/');
      const AnalyticsWrapperWithFold = withIsAboveFoldProvider(AnalyticsDataWrapper, index < ABOVE_FOLD_THRESHOLD ? 'above' : 'below');
      return /*#__PURE__*/_jsx(AnalyticsWrapperWithFold, _objectSpread(_objectSpread({}, trackable), {}, {
        "data-id": "products-list_index_ProductsList_AnalyticsWrapperWithFold",
        children: /*#__PURE__*/_jsx(TrackBox, {
          onCreateImpressionWhenView: () => {
            trackProductListViewedEvent(product, {
              listId,
              sortMethod: sort
            });
          },
          "data-id": "products-list_index_ProductsList_AnalyticsWrapperWithFold_TrackBox",
          children: /*#__PURE__*/_jsx(ProductCard, {
            product: product,
            analytics: {
              queryID: analytics === null || analytics === void 0 ? void 0 : analytics.queryID,
              indexName: analytics === null || analytics === void 0 ? void 0 : analytics.indexName,
              position: algoliaInsightsIndex,
              listId,
              sortMethod: sort !== null && sort !== void 0 ? sort : ''
            },
            priceRange: priceRange(product),
            discountedPriceRange: discountedPriceRange(product),
            discountPercentageRange: discountPercentageRange(product),
            "data-id": "products-list_index_ProductsList_TrackBox_ProductCard"
          })
        })
      }), key);
    })
  });
};

export default ProductsList;